<script>
import RadioButton from 'element-ui/lib/radio-button';

export default RadioButton;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/radio-button.css';
// Adding RTL support to element's radio button

.el-radio-button {
  &__orig-radio {
    @include rtl() {
      left: 999px;
    }
  }

  &__inner {
    @include rtl() {
      border-left: 1px solid rgb(191, 201, 217);
      border-right: 0;
    }
  }

  &:first-child .el-radio-button__inner {
    @include rtl() {
      border-right: 1px solid rgb(191, 201, 217);
      border-radius: 0 4px 4px 0;
    }
  }

  &:last-child .el-radio-button__inner {
    @include rtl() {
      border-radius: 4px 0 0 4px;
    }
  }
}
</style>
